<template>
  <v-cotainer fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Product Manufacturing
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn outlined @click="addMenufacturing()">
            <v-icon left color="teal">add</v-icon>
            New Item
          </v-btn>
          <!-- <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link> -->
        </v-toolbar>

        <v-data-table
          :headers="manufHeader"
          :items="productMenufsList"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ getProductName(props.item.productId) }}</b>
            </td>
            <td>
              <b>{{
                new Date(props.item["date"]).toLocaleDateString("en-GB")
              }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="edit(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteMenuf(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Start Product Set Dialog -->
    <v-dialog v-model="menufDialog" persistent max-width="1000px">
      <v-card persistent v-if="currentMenuf">
        <v-card-title class="primary white--text">
          <span class="headline">Manufacture Product</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datePicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="currentMenuf.date"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="currentMenuf.date"
                    @input="datePicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm4>
                <v-select
                  dense
                  autocomplete
                  :items="productsByBrand"
                  label="Result Product"
                  v-model="currentMenuf.productId"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  v-model.number="currentMenuf.quantity"
                  label="Quantity"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              wrap
              v-for="(item, index) in currentMenuf.rawMaterials"
              :key="index + 'a'"
            >
              <v-flex xs4 sm4 md4 style="display: inline-flex">
                <v-select
                  dense
                  autocomplete
                  :items="productsByBrand"
                  label="Raw Product"
                  v-model="item.productId"
                ></v-select>
              </v-flex>
              <v-flex xs4 sm4 md4>
                <v-text-field
                  v-if="item.productId"
                  type="number"
                  v-model.number="item.quantity"
                  label="Quantity"
                >
                </v-text-field>
              </v-flex>
              <v-flex :key="index + item.productId + 'add'" xs4 sm4 md4>
                <v-btn
                  icon
                  color="primary"
                  v-if="
                    index == currentMenuf.rawMaterials.length - 1 &&
                    item.productId
                  "
                  @click="addProd()"
                >
                  <v-icon>add_circle</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="primary"
                  @click="removeProd(index)"
                  v-if="index != 0 && item.productId"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="menufDialog = false" flat
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            @click="update()"
            v-if="currentMenuf['.key']"
            flat
            >Update</v-btn
          >
          <v-btn v-else color="blue darken-1" @click="save()" flat
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      datePicker: null,
      menufDialog: false,
      currentMenuf: null,
      manufHeader: [
        { text: "Product Name", value: "deposit - ID" },
        { text: "Date", value: "name" },
        { text: "Delete", value: "edit" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "productMenufs",
        this.$root.$firebaseRefs.productManufactureTransaction
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    productsByBrand() {
      return this.products
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    productMenufsList() {
      return this.productMenufs;
    },
  },
  methods: {
    save() {
      this.convert("save");
    },
    saveFinal() {
      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      this.$root.$firebaseRefs.productManufactureTransaction.push(
        this.currentMenuf
      );
      this.menufDialog = false;
    },
    addMenufacturing() {
      this.currentMenuf = {
        brand: this.selectedBrand,
        date: new Date().toISOString().substr(0, 10),
        productId: null,
        quantity: 1,
        rawMaterials: [
          {
            productId: null,
            quantity: 1,
          },
        ],
      };
      this.menufDialog = true;
    },
    addProd() {
      let itemToAdd = {
        productId: null,
        quantity: 1,
      };
      this.currentMenuf.rawMaterials.push(itemToAdd);
    },
    removeProd(index) {
      this.currentMenuf.rawMaterials.splice(index, 1);
    },
    edit(productSet) {
      this.currentMenuf = productSet;
      this.currentMenuf.date = new Date(this.currentMenuf.date)
        .toISOString()
        .substr(0, 10);
      this.menufDialog = true;
    },
    update() {
      this.convertBack("update");
    },
    updateFinal() {
      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      let key = this.currentMenuf[".key"];
      delete this.currentMenuf[".key"];
      this.$root.$firebaseRefs.productManufactureTransaction
        .child(key)
        .update(this.currentMenuf)
        .then((data) => {
          this.currentMenuf = null;
          this.menufDialog = false;
        })
        .catch((error) => {
          console.log(error.code, error.message);
        });
    },
    deleteMenuf(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.currentMenuf = productSet;
        this.convertBack("delete");
      }
    },
    getProductName(key) {
      return this.products.find((item) => item[".key"] == key).name;
    },

    deletefinal() {
      this.$root.$firebaseRefs.productManufactureTransaction
        .child(this.currentMenuf[".key"])
        .remove();
    },
    convert(action) {
      let total = this.currentMenuf.rawMaterials.length;
      this.currentMenuf.rawMaterials.map((raw, index) => {
        let prod = {...this.products.find((item) => item[".key"] == raw.productId)};
        if (prod) {
          let saleQuantity = prod["saleQuantity"] ? prod["saleQuantity"] : 0;
          saleQuantity = saleQuantity + Number.parseInt(raw.quantity);
          let prodQuantity = prod["quantity"];
          prodQuantity =
            Number.parseInt(prodQuantity) - Number.parseInt(raw.quantity);
          let key = prod[".key"];
          delete prod[".key"];
          prod["quantity"] = prodQuantity;
          this.$root.$firebaseRefs.products.child(key).set(prod);
          if (index == total - 1) {
            let prod = {...this.products.find(
              (item) => item[".key"] == this.currentMenuf.productId
            )};
            if (prod) {
              let purchaseQuantity = prod["purchaseQuantity"]
                ? prod["purchaseQuantity"]
                : 0;
              purchaseQuantity =
                purchaseQuantity + Number.parseInt(this.currentMenuf.quantity);
              let prodQuantity = prod["quantity"];
              prodQuantity =
                Number.parseInt(prodQuantity) +
                Number.parseInt(this.currentMenuf.quantity);
              let key = prod[".key"];
              delete prod[".key"];
              prod["quantity"] = prodQuantity;
              this.$root.$firebaseRefs.products.child(key).set(prod);
              this.performAction(action, true);
            }
          }
        }
      });
    },
    convertBack(action) {
      let total = this.currentMenuf.rawMaterials.length;
      this.currentMenuf.rawMaterials.map((raw, index) => {
        let prod = {...this.products.find((item) => item[".key"] == raw.productId)};
        if (prod) {
          let purchaseQuantity = prod["purchaseQuantity"]
            ? prod["purchaseQuantity"]
            : 0;
          purchaseQuantity = purchaseQuantity + Number.parseInt(raw.quantity);
          let prodQuantity = prod["quantity"];
          prodQuantity =
            Number.parseInt(prodQuantity) + Number.parseInt(raw.quantity);
          let key = prod[".key"];
          delete prod[".key"];
          prod["quantity"] = prodQuantity;

          this.$root.$firebaseRefs.products.child(key).set(prod);
          if (index == total - 1) {
            let prod = {...this.products.find(
              (item) => item[".key"] == this.currentMenuf.productId
            )};
            if (prod) {
              let saleQuantity = prod["saleQuantity"]
                ? prod["saleQuantity"]
                : 0;
              saleQuantity =
                saleQuantity + Number.parseInt(this.currentMenuf.quantity);
              let prodQuantity = prod["quantity"];
              prodQuantity =
                Number.parseInt(prodQuantity) -
                Number.parseInt(this.currentMenuf.quantity);
              let key = prod[".key"];
              delete prod[".key"];
              prod["quantity"] = prodQuantity;
              this.$root.$firebaseRefs.products.child(key).set(prod);
              this.performAction(action, false);
            }
          }
        }
      });
    },
    performAction(action, isUpdateDone) {
      switch (action) {
        case "save": {
          this.saveFinal();
          break;
        }
        case "update": {
          if (isUpdateDone) {
            this.updateFinal();
          } else {
            this.convert(action);
          }
          break;
        }
        case "delete": {
          this.deletefinal();
          break;
        }
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Settings/ProductManufacturing/ProductManufacturing.vue